"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIZARD_SORTING_VALUES = void 0;
const WIZARD_SORTING_VALUES = exports.WIZARD_SORTING_VALUES = {
  'utility:desc': 'Utility descending',
  'price:asc': 'Price ascending',
  'price:desc': 'Price descending',
  'created_at:desc': 'Newest',
  'customer_rating:desc': 'Customer Rating'
};